import type { IntlShape } from 'react-intl';

import { messages } from '../messages';
import type { BoxResult } from '../types';

export const formatPackageDimensions = (box: BoxResult['box'], sellerDimensionUnit: string, intl: IntlShape): string | null => {
  if (!box?.length || !box?.width || !box?.height) return null;
  const isInches = (sellerDimensionUnit ?? 'Inches').toLowerCase() === 'inches';
  const unitSymbol = isInches ? intl.formatMessage(messages.unitInches) : intl.formatMessage(messages.unitCentimeters);
  const format = (value: number) => Math.round(value * 10) / 10;
  return intl.formatMessage(messages.dimensionFormat, {
    length: format(box.length),
    width: format(box.width),
    height: format(box.height),
    unit: unitSymbol,
  });
};
